import React from "react";
import PropTypes from "prop-types";
import { TextEditor, CustomButton, Label } from "@helloaudio/ui";
import { useNavigate } from "react-router-dom";

function Appearance({ setFieldValue, values, feedEpisode, handleSubmit, loading }) {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <Label className="tw-cursor-pointer tw-my-4 tw-text-sm">Show Notes</Label>
      <TextEditor
        className="-tw-mt-2 tw-mb-4"
        onChange={(e) => {
          setFieldValue("description", e);
        }}
        placeholder="Type here..."
        value={values.description}
      />

      <Label className="tw-cursor-pointer tw-mb-4 tw-text-sm">Universal Footer</Label>
      <TextEditor
        className="-tw-mt-2 tw-mb-4"
        onChange={(e) => setFieldValue("universalFooter", e)}
        placeholder="(Optional) Append this to the end of the show notes for every episode in this feed."
        value={values.universalFooter}
      />

      <div className="tw-flex tw-justify-end tw-mt-4 tw-mb-8">
        <CustomButton
          className="tw-mr-4 tw-text-base custom-btn-danger"
          onClick={() => navigate(`/feed/${feedEpisode.feed_id}`)}
        >
          Cancel
        </CustomButton>
        <CustomButton
          className="tw-mr-4 tw-text-center custom-btn"
          disabled={loading}
          onClick={handleSubmit}
        >
          Confirm
        </CustomButton>
      </div>
    </React.Fragment>
  );
}

Appearance.propTypes = {
  feedEpisode: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};

export default Appearance;
